<div class="rules-container">
    <div class="rules-title">{{'Navbar_Item_Rules' | transformText}}</div>
    <div class="cards-container" data-aos="slide-up" data-aos-duration="700">
        <rule-card *ngFor="let card of cards" 
                [icon]="card.icon" 
                [title]="card.title" 
                [text]="card.text">
        </rule-card>
    </div>
</div>